module.exports = __webpack_public_path__ + "img/rankicon@2x.4f09454b.png";